import React, { useState, useEffect, useContext, forwardRef } from "react";

import { DivisionContext } from "context/CommonProvider";

import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

const SelectDivisionType = forwardRef((props, ref) => {
  const [division, setDivision] = useState(null);
  const [errorDivision, setErrorDivision] = useState(null);

  const handleChange = (event, newValue) => {
    setDivision(newValue);

    props.parentCallback(newValue);
  };

  useEffect(() => {
    setDivision(props.dataParentToChild);
    setErrorDivision(props.errorParentToChild);
  }, [props.dataParentToChild, props.errorParentToChild]);

  const divisionContext = useContext(DivisionContext);
  const items = [];
  for (var [key, value] of Object.entries(divisionContext)) {
    items.push({ label: value, id: key });
  }

  return (
    <Autocomplete
      disableClearable
      value={division}
      onChange={handleChange}
      disablePortal
      id="division"
      options={items}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, value) =>
        value === undefined ||
        value === "" ||
        option.id === value.id ||
        option.nome === value.nome
      }
      noOptionsText={"Nenhum cadastrado"}
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          margin="dense"
          inputRef={ref}
          error={errorDivision}
          label="Tipo de Divisão"
        />
      )}
    />
  );
});

export default SelectDivisionType;
